import React from 'react';
import { Link } from 'carbon-components-react';

const Password: React.FC<Props> = () => {
  return (
    <div id="pageDirectory" className="page-directory spacing-padding">
      <div className="directory-title">On this page</div>
      <div className="user-details">
        <div>User details</div>
        <div className="link-rows">
          <Link href="#profileSummary" className="directory-link">
            Profile summary
          </Link>
        </div>
        <div className="link-rows">
          <Link href="#password" className="directory-link">
            Password
          </Link>
        </div>
      </div>

      <div className="user-preferences">
        <div>User preferences</div>
        <div className="link-rows">
          <Link href="#receivingResponses" className="directory-link">
            Receiving responses
          </Link>
        </div>
        <div className="link-rows">
          <Link href="#notifications" className="directory-link">
            Notifications
          </Link>
        </div>
      </div>

      <div className="dbyd-account-details">
        <div>BYDA account details</div>
        <div className="link-rows">
          <Link href="#dbydLinkStatus" className="directory-link">
            Before You Dig link status
          </Link>
        </div>
      </div>
    </div>
  );
};

interface Props {}

export default React.memo(Password);
